
import React from 'react';
import { Chrome } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import { Button } from '../../components/ui/Button';

export const GoogleButton: React.FC<{ isLoading: boolean; onLoading: (val: boolean) => void }> = ({ isLoading, onLoading }) => {
  const handleLogin = async () => {
    onLoading(true);
    try {
      const { error } = await supabase.auth.signInWithOAuth({ 
        provider: 'google',
        options: { redirectTo: `${window.location.origin}/auth/callback` }
      });
      if (error) throw error;
    } catch (err) {
      console.error(err);
      onLoading(false);
    }
  };

  return (
    <Button 
      variant="outline" 
      onClick={handleLogin} 
      isLoading={isLoading}
      className="w-full py-5 text-xs"
      icon={<Chrome size={20} className="text-rose-500" />}
    >
      Sign in with Google
    </Button>
  );
};
